export default __webpack_public_path__ + "static/8-cc163bc35ed0f27e2306382b754d73ad.jpg";